// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICompanyApi,
  ICompanyApiRequest,
  ICompanyApiGetDropdownAttrs,
  ICompanyApiDropdownResponse,
  ICompanyApiDetailResponse,
  ICompanyApiGetDetailAttrs,
  ICompanyApiGetListAttrs,
  ICompanyApiListResponse,
  ICompanyApiUpdateAttrs,
  ICompanyApiNullResponse,
} from 'interfaces/back-office/master/company/company-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class CompanyApi extends BaseApi<ICompanyApi> implements ICompanyApiRequest {
  readonly url = ApiConstant.MASTER_COMPANY_URL
  private companyUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get company list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICompanyApiGetListAttrs} payload
   *
   * @return {Promise<ICompanyApiListResponse>} Promise<ICompanyApiListResponse>
   */
  async masterCompany_getList(payload: ICompanyApiGetListAttrs): Promise<ICompanyApiListResponse> {
    return this.POST(`${this.companyUrl}/list`, payload.body, {
      ...payload.requestConfig,
    })
  }

  /**
   * @description Get company dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICompanyApiGetDropdownAttrs} payload
   *
   * @return {Promise<ICompanyApiDropdownResponse>} Promise<ICompanyApiDropdownResponse>
   */
  async masterCompany_getDropdown(payload: ICompanyApiGetDropdownAttrs): Promise<ICompanyApiDropdownResponse> {
    return this.POST(`${this.companyUrl}/dropdown`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Get company
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICompanyApiGetDetailAttrs} payload
   *
   * @return {Promise<ICompanyApiDetailResponse>} Promise<ICompanyApiDetailResponse>
   */
  async masterCompany_getDetail(payload: ICompanyApiGetDetailAttrs): Promise<ICompanyApiDetailResponse> {
    return this.POST(`${this.companyUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Save company
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICompanyApiUpdateAttrs} payload
   *
   * @return {Promise<ICompanyApiNullResponse>} Promise<ICompanyApiNullResponse>
   */
  async masterCompany_update(payload: ICompanyApiUpdateAttrs): Promise<ICompanyApiNullResponse> {
    return this.POST(`${this.companyUrl}/update/${payload.params.id}`, payload.body, {
      ...payload.requestConfig,
    })
  }
}
